import { Country,State } from "country-state-city";

// Fetch base country options once
const countryOptions = Country.getAllCountries();

// 1. Phone Country Code Options
export const countryCodeOptions = countryOptions.map((c) => ({
  value: `+${c.phonecode}`,
  label: `+${c.phonecode}`,
}));

// 2. Country ISO Options
export const countries = countryOptions.map((c) => ({
  value: c.isoCode || c.code,
  label: c.name,
}));

export const CURRENCY_SYMBOLS = {
  INR: "₹",
  USD: "$",
  EUR: "€",
  GBP: "£",
  CAD: "CA$",
  AUD: "A$",
  JPY: "¥",
  AED: "AED ",
};

// Helper function to get currency symbol by code with fallback
export const getCurrencySymbol = (currencyCode) => {
  if (!currencyCode) return "€";
  return CURRENCY_SYMBOLS[currencyCode.toUpperCase()] || `${currencyCode} `;
};

// Format currency options array for selects (e.g., { value: "INR", label: "INR - ₹ (India)" })
export const currencyOptions = Array.from(
  new Map(
    countryOptions
      .filter((c) => c.currency)
      .map((c) => {
        const symbol = getCurrencySymbol(c.currency);
        return [
          c.currency,
          {
            value: c.currency,
            label: `${c.currency} - ${symbol} (${c.name})`,
            symbol: symbol,
            country: c.name,
          },
        ];
      })
  ).values()
).sort((a, b) => a.value.localeCompare(b.value));


export const getCountryName = (countryCode) => {
  if (!countryCode) return "";
  const country = Country.getCountryByCode(countryCode.toUpperCase());
  return country ? country.name : countryCode;
};


export const getStateName = (countryCode, stateCode) => {
  if (!countryCode || !stateCode) return stateCode || "";
  const state = State.getStateByCodeAndCountry(
    stateCode.toUpperCase(),
    countryCode.toUpperCase()
  );
  return state ? state.name : stateCode;
};
